import { RequestQueueItem } from "@/types/requestQueue";

export const mapRequestQueueItemForCopy = ({
    metadata,
    commands,
}: RequestQueueItem) => ({
    metadata,
    commands,
});
